/*
Mapeado para HomeRequest para no repetirme --> hay que ubicarlos correctamente
 */

function mapper (array = [], ...parameters)
{
    if(parameters.includes('search')) {
        return array.map(function (employee) {
            return splitDataOfMapper(mapperParameters(employee, parameters))
        })
    }
    return []
}

/**
 * Mapea los datos y los entrega en cadana de text
 * @param employee
 * @param parameters
 * @returns {string}
 */
function mapperParameters(employee = {}, parameters = []) {
    let data = ''
    for (const key of parameters) {
        if (employee[key]) {
            data += `${key},${employee[key]},name_to_search,Nombre: ${employee['name']} CC: ${employee['cc']} SharpId: ${employee['sharp_id']},`
        }
    }
    return data
}


/**
 * Convierte la cadena de texto en array con su key
 * @param data
 * @returns {{}}
 */
function splitDataOfMapper (data = '') {
    let temp = data.split(','), obj = {}
    for (let i=0; i<temp.length; i+=2) { obj[temp[i]] = temp[(i+1)] }
    return obj
}

export {
    mapper
}